import { render, staticRenderFns } from "./RepairFormAssignationStep.vue?vue&type=template&id=58c0480b&scoped=true"
import script from "./RepairFormAssignationStep.vue?vue&type=script&lang=js"
export * from "./RepairFormAssignationStep.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58c0480b",
  null
  
)

export default component.exports